import { useState, useEffect } from 'react';
import { getAuthUrl, getAccessToken } from './services/spotifyService';
import GameBoard from './components/GameBoard';
import './App.css';

function App() {
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code && !accessToken) {
      exchangeCodeForToken(code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exchangeCodeForToken = async (code) => {
    setLoading(true);
    try {
      const tokenData = await getAccessToken(code);
      setAccessToken(tokenData.access_token);
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (err) {
      setError('Failed to authenticate with Spotify');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    try {
      const authUrl = await getAuthUrl();
      window.location.href = authUrl;
    } catch (err) {
      setError('Failed to start Spotify login');
      console.error(err);
    }
  };

  const handleLogout = () => {
    setAccessToken(null);
  };

  if (loading) {
    return (
      <div className="app loading">
        <div className="loader">Authenticating with Spotify...</div>
      </div>
    );
  }

  if (!accessToken) {
    return (
      <div className="app login-screen">
        <div className="login-container">
          <h1>Hitster</h1>
          <p>A music guessing game powered by Spotify</p>

          {error && <div className="error-message">{error}</div>}

          <button className="login-button" onClick={handleLogin}>
            Login with Spotify
          </button>

          <p className="info-text">
            A Spotify Premium account is required to play.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>Hitster</h1>
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </header>
      <main>
        <GameBoard accessToken={accessToken} />
      </main>
    </div>
  );
}

export default App;
